import reducer from "./reducer";
export { default as SystemAndUserTables } from "./components/index";
export { default as systemAndUserTablesReducerName } from "./constants";
export default reducer;
